import React, { useEffect, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { reviewApi } from "./api";
export default function BetaParticipation() {
  const [data, setData] = useState<any>(null),
    [accepted, setAccepted] = useState(false),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  useEffect(() => {
    const c = new AbortController();
    reviewApi("/participation", "GET", undefined, c.signal)
      .then(setData)
      .catch(e => {
        if (!c.signal.aborted) setError(e.message);
      });
    return () => c.abort();
  }, []);
  async function submit() {
    setBusy(true);
    setError("");
    try {
      await reviewApi("/participation", "POST", {
        accepted: true,
        version: data.notice.version,
        hash: data.notice.hash,
      });
      setData({ ...data, accepted: true });
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <section className="reviewed-note mb-4">
      <h2 className="h5">Test-beta participation</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      {data ? (
        data.accepted ? (
          <p role="status">
            You accepted {data.notice.version}. Conflict checks are still
            required for each request.
          </p>
        ) : (
          <>
            <p>
              Accept this notice before receiving test assignments. It is
              separate from a real attorney participation agreement.
            </p>
            <details>
              <summary>Read the full participation notice</summary>
              <p>{data.notice.text}</p>
              <small>{data.notice.version}</small>
            </details>
            <Form.Check
              className="my-3"
              id="beta-participation"
              label="I have read and accept this test-beta participation notice."
              checked={accepted}
              onChange={e => setAccepted(e.target.checked)}
            />
            <Button disabled={!accepted || busy} onClick={submit}>
              {busy ? "Saving…" : "Accept test-beta participation"}
            </Button>
          </>
        )
      ) : (
        <p role="status">Loading participation notice…</p>
      )}
    </section>
  );
}
